import { render, staticRenderFns } from "./brandLogoView.vue?vue&type=template&id=9598a3f2&scoped=true&"
import script from "./brandLogoView.vue?vue&type=script&lang=js&"
export * from "./brandLogoView.vue?vue&type=script&lang=js&"
import style0 from "./brandLogoView.vue?vue&type=style&index=0&id=9598a3f2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9598a3f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,ALink: require('/app/components/aLink.vue').default,ObserverHOC: require('/app/components/ObserverHOC/index.vue').default})
